import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 数据收集
interface CollectJson {
    series?: number,
}
export const collect = (json: CollectJson): any => http.httpPost({
    url: httpApi.collection.collect,
    json
})
// 数据收集
interface CollectJson {
    series?: number,
}
export const competitionCollect = (json: CollectJson): any => http.httpPost({
    url: httpApi.collection.competitionCollect,
    json
})
